import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { EmployeeService } from '../../services/employee.service';
import { SecurityReport, SecurityReportEmployee, SecurityReportService } from '../../services/security-report.service';

@Component({
  selector: 'app-display-security-report',
  templateUrl: './display-security-report.component.html',
  styleUrls: ['./display-security-report.component.css']
})
export class DisplaySecurityReportComponent implements OnInit {

  id: string;
  reportEmployees: SecurityReportEmployee[]  = [];

  subs: Subscription[] = [];

  form: FormGroup;

  constructor(
    private service: SecurityReportService,
    private employeeService: EmployeeService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
  ) {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');

    this.subs[0] = this.service.getSecurityReport(this.id).subscribe(report => {
      this.form.patchValue(report);
      this.reportEmployees = report.employees;
    });
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      employeeName: '',
      date: '',
      time: '',
    });
  }
  ngOnDestroy(){
    for(let sub of this.subs) sub.unsubscribe();
  }

  onCancel(){
    this.service.windowReplace.read();
  }

}
